/**
 * Shared vocabulary for interview screens.
 *
 * Kept out of the page modules so react-refresh sees only components there,
 * and so both sides of the marketplace label the same status the same way.
 */

export const INTERVIEW_TONES = {
  SCHEDULED: 'info',
  COMPLETED: 'success',
  CANCELLED: 'neutral',
  NO_SHOW: 'danger',
};

export const INTERVIEW_LABELS = {
  SCHEDULED: 'Scheduled',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
  NO_SHOW: 'Missed',
};

export const RESPONSE_TONES = {
  PENDING: 'warning',
  ACCEPTED: 'success',
  DECLINED: 'danger',
};

export const RESPONSE_LABELS = {
  PENDING: 'Awaiting reply',
  ACCEPTED: 'Confirmed',
  DECLINED: 'Declined',
};

export const MODE_LABELS = {
  VIDEO: 'Video call',
  PHONE: 'Phone call',
  ONSITE: 'On site',
};

export const RECOMMENDATION_LABELS = {
  STRONG_YES: 'Strong yes',
  YES: 'Yes',
  NO: 'No',
  STRONG_NO: 'Strong no',
};

export const RECOMMENDATION_TONES = {
  STRONG_YES: 'success',
  YES: 'success',
  NO: 'warning',
  STRONG_NO: 'danger',
};

export function hasInterviewStarted(interview, now = new Date()) {
  const start = new Date(interview?.scheduled_at);
  return Number.isNaN(start.getTime()) ? false : start.getTime() <= now.getTime();
}

export function isStudentMissedInterview(interview, now = new Date()) {
  if (interview?.status === 'NO_SHOW') return true;
  return (
    interview?.status === 'SCHEDULED' &&
    hasInterviewStarted(interview, now) &&
    interview.student_response !== 'ACCEPTED'
  );
}

/** Where and how to join, as one line. */
export function whereToGo(interview) {
  if (interview.mode === 'ONSITE') return interview.location;
  if (interview.mode === 'VIDEO') return interview.meeting_url;
  return 'The company will call you';
}

/** "Thu 21 Aug, 10:00 — 10:45" in the viewer's own locale and timezone. */
export function interviewWhen(interview) {
  const start = new Date(interview.scheduled_at);
  const end = new Date(start.getTime() + interview.duration_minutes * 60_000);
  const day = start.toLocaleDateString(undefined, {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
  });
  const time = (value) =>
    value.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });
  return `${day}, ${time(start)} — ${time(end)}`;
}

/** The value a datetime-local input wants, from a Date. */
export function toLocalInputValue(date) {
  const offset = date.getTimezoneOffset() * 60_000;
  return new Date(date.getTime() - offset).toISOString().slice(0, 16);
}
